import { FC } from "react";

interface InvalidSVGProps {
    className?: string;
}

const InvalidSVG: FC<InvalidSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 13.9994L12.4999 21M12.4999 13.9994L20 21M29.3708 16.9993C29.3708 24.3631 23.4012 30.3327 16.0374 30.3327C8.67366 30.3327 2.7041 24.3631 2.7041 16.9993C2.7041 9.63557 8.67366 3.66602 16.0374 3.66602C23.4012 3.66602 29.3708 9.63557 29.3708 16.9993Z"
                stroke="#993B3B"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default InvalidSVG;
